import { Link, useLocation } from 'react-router-dom'
import { navItems, type NavItem } from '../nav-items'
import ThemeToggle from './ThemeToggle'
import { useAuth } from '../hooks/useAuth'

// Same longest-prefix-match used by BottomNav.
function activeItemPath(items: NavItem[], pathname: string): string | null {
  const matches = items.filter((i) =>
    i.path === '/' ? pathname === '/' : pathname === i.path || pathname.startsWith(i.path + '/'),
  )
  if (matches.length === 0) return null
  return matches.sort((a, b) => b.path.length - a.path.length)[0].path
}

export default function Sidebar() {
  const { signOut } = useAuth()
  const { pathname } = useLocation()
  const activePath = activeItemPath(navItems, pathname)
  return (
    <aside
      style={{
        width: 'var(--sidebar-width-desktop)',
        height: '100vh',
        background: 'var(--color-surface)',
        borderRight: '1px solid var(--color-border)',
        padding: 'var(--space-4) 0',
        display: 'flex',
        flexDirection: 'column',
        position: 'sticky',
        top: 0,
      }}
    >
      <div
        style={{
          padding: '0 var(--space-5) var(--space-6)',
          fontWeight: 700,
          color: 'var(--color-primary)',
        }}
      >
        🖨️ Print Tracker
      </div>
      <nav style={{ flex: 1 }}>
        {navItems.map((item) => {
          const isActive = item.path === activePath
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-3)',
                padding: 'var(--space-3) var(--space-5)',
                color: isActive ? 'var(--color-primary)' : 'var(--color-text-muted)',
                background: isActive ? 'var(--color-primary-soft)' : 'transparent',
                borderRight: isActive
                  ? '3px solid var(--color-primary)'
                  : '3px solid transparent',
                fontWeight: isActive ? 600 : 400,
                fontSize: 'var(--font-size-sm)',
                textDecoration: 'none',
              }}
            >
              <span style={{ fontSize: '1.1rem' }}>{item.icon}</span>
              {item.label}
            </Link>
          )
        })}
      </nav>
      <div style={{ padding: '0 var(--space-5)' }}>
        <div style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center', flexWrap: 'wrap' }}>
          <Link to="/journal" title="Journal" aria-label="Journal" style={iconBtnStyle}>
            📓
          </Link>
          <Link to="/calendar" title="Calendar" aria-label="Calendar" style={iconBtnStyle}>
            📅
          </Link>
          <Link
            to="/calculator"
            title="Pricing calculator"
            aria-label="Pricing calculator"
            style={iconBtnStyle}
          >
            🧮
          </Link>
          <ThemeToggle />
          <Link
            to="/maintenance"
            title="Maintenance"
            aria-label="Maintenance"
            style={iconBtnStyle}
          >
            🔧
          </Link>
        </div>
        <button
          onClick={signOut}
          style={{
            marginTop: 'var(--space-4)',
            color: 'var(--color-text-muted)',
            fontSize: 'var(--font-size-sm)',
          }}
        >
          Sign out
        </button>
      </div>
    </aside>
  )
}

const iconBtnStyle = {
  width: 36,
  height: 36,
  background: 'var(--color-surface-2)',
  borderRadius: 'var(--radius-pill)',
  fontSize: '1.1rem',
  lineHeight: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  color: 'inherit',
} as const
